<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title161"></a>
<div class="p"><span><em class="i">Dedicated to Bonnie S. Wilford</em></span></div>
<div class="p"><span><em class="i">May 19, 1949—March 10, 2003</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span><em class="i">“She worketh willingly with her hands …<br/> let her own works praise her in the gates.”</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821378_ded01.vue?48dc13c0